<main class="request-instructor" [ngStyle]="{ 'margin-top' : isSetTopMargin() ? '10px' : '145px'}">
  <section class="about-section edit-section user-info-tab">
    <div class="container px-md-0">
      <div class="row">
        <div class="col-12 col-md-3 col-lg-3">
          <ul class="list-group">
            <ng-container *ngFor="let tab of tabs">
              <ng-container>
                <li class="list-group-item" [hidden]="tab.title === 'my_feedbacks' && !instructorFeedbacks?.length">
                  <a class="list-group-item-action" [class.active]="tab.isActive"
                     (click)="changeTab(tab)">
                    {{(translationScope + '.tabs.instructor_request.' + tab.title) | transloco}}
                    <ng-container *ngIf="tab.isApprove">
                    <span>
                      <i class="fa fa-check-circle approved" aria-hidden="true"></i>
                    </span>
                    </ng-container>
                    <ng-container *ngIf="tab.isRejected">
                    <span>
                      <i class="fa fa-times-circle rejected" aria-hidden="true"></i>
                    </span>
                    </ng-container>
                    <ng-container *ngIf="tab.isPending">
                      <span class="text-uppercase pending">Pending</span>
                    </ng-container>
                  </a>
                </li>
              </ng-container>
            </ng-container>
          </ul>
        </div>
        <div class="col-12 col-md-9 col-lg-9">
          <div class="edit-experience-form">
            <div class="login-form">
              <div class="needs-validation" novalidate>
                <div class="tab-content" id="experience-tab">
                  <div *ngIf="tabUtility.IsTabActive('basic-info')" class="tab-pane fade show active" role="tabpanel">
                    <basic-info-form
                      [isTabReadOnly]="isApplicationReadOnly"
                      [instructorStatus]="instructorStatus"
                      (complete)="tabUtility.CompleteTab($event)"
                      (approve)="tabUtility.ApproveTab($event)" (pending)="tabUtility.PendingTab($event)"
                      (reset)="tabUtility.ResetTab($event)"
                      (reject)="tabUtility.RejectTab($event)" (formSubmit)="tabUtility.ActiveTab($event)">
                    </basic-info-form>
                  </div>
                  <div *ngIf="tabUtility.IsTabActive('id-verification')" class="tab-pane fade show active"
                    role="tabpanel">
                    <identity-verification-form
                      [isTabReadOnly]="isApplicationReadOnly"
                      (OnBack)="tabUtility.ActiveTab($event)"
                      (OnPending)="tabUtility.PendingTab($event)" (OnComplete)="tabUtility.CompleteTab($event)"
                      (OnSubmit)="tabUtility.ActiveTab($event)">
                    </identity-verification-form>
                  </div>
                  <div *ngIf="tabUtility.IsTabActive('bank-account')" class="tab-pane fade show active" role="tabpanel">
                    <bank-account-form
                      [isTabReadOnly]="isApplicationReadOnly"
                      (OnBack)="tabUtility.ActiveTab($event)"
                      (OnComplete)="tabUtility.ApproveTab($event)"
                      (OnSubmit)="tabUtility.ActiveTab($event)">
                    </bank-account-form>
                  </div>
                  <div *ngIf="tabUtility.IsTabActive('my-courses')" class="tab-pane fade show active" role="tabpanel">
                    <my-courses-create
                      [isTabReadOnly]="isApplicationReadOnly"
                      (OnBack)="tabUtility.ActiveTab($event)">
                    </my-courses-create>
                  </div>
                  <div *ngIf="tabUtility.IsTabActive('my-feedbacks')" class="tab-pane fade show active" role="tabpanel">
                    <app-my-feedbacks
                      (OnBack)="tabUtility.ActiveTab($event)"
                      [feedbacks]="instructorFeedbacks"
                    ></app-my-feedbacks>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>
